import React, { useState, useEffect } from "react";
import { connect, useDispatch } from "react-redux";
import { useRecoilState } from "recoil";
import { modalCallbacksAtom, modalExtraDataAtom } from "../../Modal/atoms";
import FileUpload from "../FileUpload";

const AddApplicationDocumentsModal = (props) => {
  const dispatch = useDispatch();
  const [files, setFiles] = useState([]);
  // const [hidden, setHidden] = useState(false);
  // const [failedUploads, setFailedUploads] = useState({});
  const [modalExtraData, setModalExtraData] =
    useRecoilState(modalExtraDataAtom);
  const [modalCallbacks, setModalCallbacks] =
    useRecoilState(modalCallbacksAtom);

  useEffect(() => {
    const { input } = props;
    let _val = input && input.value;
    let files = [];
    if (!Array.isArray(_val)) files = [];
    else files = _val;
    setFiles(files);
  }, []);

  const addNewDocuments = () => {
    const { closeModal, callbacks } = props;
    // this is where you call pushDocs to add them to fieldArray

    let _nextFiles = files.map((file) =>
      Object.assign(file, { fileUploadedFrom: "modal" })
    );
    modalCallbacks.pushDocuments(_nextFiles);
    closeModal();
  };
  const addToModalState = (_completed_files) => {
    setFiles(_completed_files);
  };

  const closeAppDocsModal = () => {
    const { closeModal } = props;
    closeModal();
  };

  return (
    <div className="mobile:grid-col-12 upload-grid-wrapper grid-col-12">
      <FileUpload
        schemaProps={modalExtraData.schemaProps.modal}
        appId={modalExtraData.application_id}
        showRequired={modalExtraData.schemaProps.showRequired}
        input={modalExtraData.input}
        formApi={modalExtraData.formApi}
        machine_name={modalExtraData.schemaProps.modal.machine_name}
        addToModalState={addToModalState}
        fieldArray={true}
      />

      <div className="form-actions">
        <div className="form-actions-left" />
        <div className="form-actions-left">
          <button
            className="usa-button btn-extra-wide usa-button-outline"
            onClick={() => closeAppDocsModal()}
          >
            Cancel
          </button>
          <button
            className="usa-button btn-extra-wide usa-button-primary"
            onClick={() => addNewDocuments()}
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
};

const fileComponent = {
  machine_name: "machine_name_of_component",
  title: "Completed Form ETA-9141C",
  label:
    "A completed Form ETA-9141C, Application for Prevailing Wage Determination, is attached to this application. $ ",
  subContent: ["HTML 1", "HTML 2"],
  fileType: "prevailing_wage",
  initialValues: [],
};

export default AddApplicationDocumentsModal;
